import React from 'react';

export default class Page6 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content" id="yui_3_17_2_1_1594717003581_34">
                    <div role="main" id="yui_3_17_2_1_1594717003581_33"><span id="maincontent"/>
                        <section id="yui_3_17_2_1_1594717003581_32">
                            <div className="" id="yui_3_17_2_1_1594717003581_31">
                                <div className="ilead-rgt people develop-pad-none"
                                     id="yui_3_17_2_1_1594717003581_30">
                                    <div className="innerpadding" id="yui_3_17_2_1_1594717003581_29">


                                        <div className="ilead-contentarea" id="yui_3_17_2_1_1594717003581_28">


                                            <table width="100%" border="0" cellSpacing="0" cellPadding="0"
                                                   className="ilead_v_sport tablesrink people_active">
                                                <tbody>
                                                <tr>
                                                    <th width="100%" align="left" valign="top" colSpan="2"
                                                        className="green_curve green_curve1">Individual
                                                        Performance
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <td width="100%" align="left" valign="top"
                                                        className="lightgreen">Feedback from them.
                                                    </td>

                                                </tr>
                                                <tr>
                                                    <td width="100%" align="left" valign="top"
                                                        className="darkgreen">Feedback from their staff.
                                                    </td>

                                                </tr>
                                                <tr>
                                                    <td width="100%" align="left" valign="top"
                                                        className="lightgreen">Feedback from peers.
                                                    </td>

                                                </tr>
                                                <tr>
                                                    <td width="100%" align="left" valign="top"
                                                        className="darkgreen">Feedback from customers.
                                                    </td>

                                                </tr>
                                                <tr>
                                                    <td width="100%" align="left" valign="top"
                                                        className="lightgreen">Your own observations.
                                                    </td>

                                                </tr>
                                                <tr>
                                                    <td width="100%" align="left" valign="top"
                                                        className="darkgreen">Performance data, for example,
                                                        were sales targets met?
                                                    </td>

                                                </tr>
                                                <tr>
                                                    <td width="100%" align="left" valign="top"
                                                        className="lightgreen">Reports from any development
                                                        activities, for example, development centres.
                                                    </td>

                                                </tr>

                                                </tbody>
                                            </table>
                                            <div className="circle_title">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span className="heading">AGREEING DEVELOPMENT GOALS</span>
                                            </div>
                                            <p>Development goals will emerge from both organisational (current
                                                and future) and individual
                                                needs. Your role is to ensure that, as far as possible, both are
                                                met. If development goals are
                                                weighted too much in favour of organisational needs, the
                                                individual may feel less motivated.</p>
                                            <p>Try to achieve a reasonable balance and agree what the goals are,
                                                with the individual and senior
                                                members of the organisation, as appropriate...</p>
                                            <p>You can do this through open and constructive discussion, and
                                                we’ve got a suggestion about how
                                                to do this next.</p>
                                            <div className="circle_title">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span
                                                    className="heading">PROCESS FOR AGREEING DEVELOPMENT GOALS</span>
                                            </div>
                                            <div className="lightgreencontentbg keyquestionpad">
                                                <ol className="brownbullet-list listcontentSpacing paraspace paratop2">
                                                    <li><p> Agree an agenda for the meeting.</p></li>
                                                    <li><p>If necessary, clarify everyone’s purpose in the
                                                        meeting and whether the discussion needs to be
                                                        confidential.</p></li>
                                                    <li><p>Ask questions to encourage the individual to offer
                                                        their own view of their strengths and development
                                                        needs.</p></li>
                                                    <li><p>Actively listen (that means acknowledge what they
                                                        say, or just nod, to demonstrate you are giving your
                                                        attention) and agree or challenge as appropriate.</p>
                                                    </li>
                                                    <li><p>Give your own views of the individual’s strengths and
                                                        development needs, using information you’ve collected,
                                                        and give examples.</p></li>
                                                    <li><p>If necessary, clarify what the organisation requires
                                                        of them and any timescales given. This may be simply
                                                        that you want them to be in line with what is expected
                                                        of someone in their role or it may focus on new skills
                                                        that will stretch them to take on new
                                                        responsibilities.</p></li>
                                                    <li><p>Ask questions to encourage the individual to describe
                                                        their aspirations and motives.</p></li>
                                                    <li><p>Where possible, make links between these and the
                                                        business’s requirements.</p></li>
                                                    <li className="uiheading"><p>Agree a manageable number of
                                                        development goals – too many will overwhelm and
                                                        de-motivate the individual.</p></li>

                                                </ol>
                                            </div>


                                            <div className="left-btn">
                                                <div onClick={this.props.handleChangePage('Page5')}
                                                     className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page7')}
                                                    className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}